<template>
  <b-card>
    <!-- form -->
    <validation-observer ref="passwordForm">
      <template #default="{ invalid }">
        <b-form @submit.prevent="submitPasswordChange">
          <b-row>
            <!-- old password -->
            <b-col md="6">
              <b-form-group
                label="Senha atual"
                label-for="account-old-password"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Senha atual"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="account-old-password"
                      v-model="passwordValueOld"
                      name="old-password"
                      :type="passwordFieldTypeOld"
                      :state="errors.length > 0 ? false : null"
                      placeholder="Senha atual"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        :icon="passwordToggleIconOld"
                        class="cursor-pointer"
                        @click="togglePasswordOld"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!--/ old password -->
          </b-row>
          <b-row>
            <!-- new password -->
            <b-col md="6">
              <b-form-group
                label-for="account-new-password"
                label="Nova Senha"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Nova Senha"
                  vid="novaSenha"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="account-new-password"
                      v-model="newPasswordValue"
                      :type="passwordFieldTypeNew"
                      :state="errors.length > 0 ? false : null"
                      name="new-password"
                      placeholder="Nova Senha"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        :icon="passwordToggleIconNew"
                        class="cursor-pointer"
                        @click="togglePasswordNew"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!--/ new password -->

            <!-- retype password -->
            <b-col md="6">
              <b-form-group
                label-for="account-retype-new-password"
                label="Confirme a nova senha"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Confirme a nova senha"
                  rules="required|confirmed:novaSenha"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="account-retype-new-password"
                      v-model="RetypePassword"
                      :type="passwordFieldTypeRetype"
                      :state="errors.length > 0 ? false : null"
                      name="retype-password"
                      placeholder="Confirme a nova senha"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        :icon="passwordToggleIconRetype"
                        class="cursor-pointer"
                        @click="togglePasswordRetype"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!--/ retype password -->

            <!-- buttons -->
            <b-col cols="12">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mt-1 mr-1"
                type="submit"
                :disabled="isSubmitting || invalid"
              >
                <b-spinner
                  v-if="isSubmitting"
                  small
                  class="mr-50"
                />
                Salvar Alterações
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="reset"
                variant="outline-secondary"
                class="mt-1"
                :disabled="isSubmitting"
                @click="resetForm"
              >
                Resetar
              </b-button>
            </b-col>
            <!--/ buttons -->
          </b-row>
        </b-form>
      </template>
    </validation-observer>
  </b-card>
</template>

<script>
import {
  BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BCard, BInputGroup, BInputGroupAppend, BSpinner,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BInputGroup,
    BInputGroupAppend,
    BSpinner,
    ValidationObserver,
    ValidationProvider,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      passwordValueOld: '',
      newPasswordValue: '',
      RetypePassword: '',
      passwordFieldTypeOld: 'password',
      passwordFieldTypeNew: 'password',
      passwordFieldTypeRetype: 'password',
      required,
      isSubmitting: false,
    }
  },
  computed: {
    passwordToggleIconOld() {
      return this.passwordFieldTypeOld === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    passwordToggleIconNew() {
      return this.passwordFieldTypeNew === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    passwordToggleIconRetype() {
      return this.passwordFieldTypeRetype === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  methods: {
    async submitPasswordChange() {
      const valid = await this.$refs.passwordForm.validate()
      if (!valid) return

      this.isSubmitting = true
      try {
        await this.$api.put('/auth/update-password', {
          senha_atual: this.passwordValueOld,
          senha: this.newPasswordValue,
          confirmar_senha: this.RetypePassword,
        })

        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Senha atualizada',
            icon: 'CheckIcon',
            variant: 'success',
            text: 'Sua senha foi alterada com sucesso.',
          },
        })

        this.resetForm()
      } catch (error) {
        const message = error.response?.data?.message
          || error.response?.data?.error
          || 'Não foi possível atualizar a senha.'

        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Erro ao atualizar senha',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: message,
          },
        })
      } finally {
        this.isSubmitting = false
      }
    },

    resetForm() {
      this.passwordValueOld = ''
      this.newPasswordValue = ''
      this.RetypePassword = ''
      this.passwordFieldTypeOld = 'password'
      this.passwordFieldTypeNew = 'password'
      this.passwordFieldTypeRetype = 'password'
      if (this.$refs.passwordForm) {
        this.$refs.passwordForm.reset()
      }
    },

    togglePasswordOld() {
      this.passwordFieldTypeOld = this.passwordFieldTypeOld === 'password' ? 'text' : 'password'
    },
    togglePasswordNew() {
      this.passwordFieldTypeNew = this.passwordFieldTypeNew === 'password' ? 'text' : 'password'
    },
    togglePasswordRetype() {
      this.passwordFieldTypeRetype = this.passwordFieldTypeRetype === 'password' ? 'text' : 'password'
    },
  },
}
</script>
